import {ErrorResponseDto, ValidationError} from "@reside/reside-api-admission";

export class FileError extends Error {
  data: {message: string};

  constructor(message: string) {
    super(message);
    this.data = {message};
    Object.setPrototypeOf(this, new.target.prototype); // Restore proper prototype chain
  }
}

export const buildResponseErrorMessage = async (
  response: any,
  defaultMessage?: string,
) => {
  const error =
    // fetch Response
    (await (async () => {
      try {
        return typeof response?.json === "function" ? await response.json() : undefined;
      } catch {
        return undefined;
      }
    })()) ??
    // apisauce / axios error shapes
    response?.data ??
    response?.response?.data ??
    {};

  return buildErrorMessage(error, defaultMessage);
};

export const buildErrorMessage = (
  error: Partial<ErrorResponseDto & {detail?: string}>,
  defaultMessage = "Something went wrong",
): string => {
  if (error?.validationErrors?.length) {
    return errorMessageFromErrorList(error.validationErrors);
  }
  const e = error as any;
  return (typeof e?.detail === "string" && e.detail.trim()) || e?.message || defaultMessage;
};

const errorMessageFromErrorList = (
  validationErrors: ReadonlyArray<ValidationError>,
): string => {
  if (validationErrors.length === 0) {
    return "";
  }

  return validationErrors
    .map(error => `${error.field} - ${error.message}`)
    .join("\n");
};
